module.exports = __webpack_public_path__ + "static/media/doc.bc5f9db1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/scenes/Files/images/doc.svg
// module id = 596
// module chunks = 0